import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import styles from "./MeetingScheduler.css";
import { MeetingSchedulerStatus } from "@fidget/common/models/meeting-scheduler-status";
import { IMeetingSchedulerChatItem } from "../../models/room/chat/items";

interface Props {
  item: IMeetingSchedulerChatItem;
  cancelScheduling: (token: string) => void;
}

/**
 * Displays status of meeting scheduling process started using
 * 'Send bot to schedule meeting' function.
 */
@observer
export class MeetingScheduler extends React.Component<Props> {
  onCancelClick = (ev: React.SyntheticEvent) => {
    this.props.cancelScheduling(this.props.item.token);
  };

  renderProgress = () => {
    const { progressStatus } = this.props.item;
    switch (progressStatus) {
      case MeetingSchedulerStatus.PENDING:
        return (
          <>
            <div className={styles["in-progress"]}>
              <i className={classNames("icon-cal-icon", styles["icon-cal-icon"])}></i>
              <L10n id={"conversation.meetingScheduler.inProgress"} />
            </div>
            <a href="#" onClick={this.onCancelClick}>
              <L10n id={"conversation.meetingScheduler.cancel"} />
            </a>
          </>
        );
      case MeetingSchedulerStatus.CANCELLED:
        return <L10n id={"conversation.meetingScheduler.cancelled"} />;
      default:
        return "";
    }
  };

  render() {
    return (
      <div className={styles.container}>
        <div>
          <div className={styles.title}>
            <L10n id={"conversation.meetingScheduler.title"} />
          </div>
          <div className={styles.status}>{this.renderProgress()}</div>
        </div>
      </div>
    );
  }
}
